module.exports = "/images/notifications-modal.png?d44e4b9b8d83c4a6b32ac4a1097e9d80";